{
  "version": 1,
  "asset_id": "ab7f71aa-6fae-4f9d-a448-e417ebd25d5e",
  "project_id": "ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe",
  "url": "/__l5e/assets-v1/ab7f71aa-6fae-4f9d-a448-e417ebd25d5e/relaycommerce-240.webp",
  "r2_key": "a/v1/ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe/ab7f71aa-6fae-4f9d-a448-e417ebd25d5e/relaycommerce-240.webp",
  "original_filename": "relaycommerce-240.webp",
  "size": 7410,
  "content_type": "image/webp",
  "created_at": "2026-09-21T21:10:19Z"
}
